import { createPaginationState } from '@/common/pagination/types.ts';

export const [salesOrderPaginationAtom, resetSalesOrderPaginationOnFilterChangeAtom] =
  createPaginationState();
